<template>
  <div>
    <template v-if="applymentDetail.businessType == 'COMPANY_INCORPORATION' || applymentDetail.businessType == 'SERVICE_TRANSFER'">
      <template v-if="applymentDetail.goodsListType == 1">
        <!-- 套餐 -->
        <Package :goodsList="applymentDetail.goodsList" />
      </template>
      <template v-if="applymentDetail.goodsListType == 2">
        <!-- 自定义套餐 -->
        <diy-package :businessType="applymentDetail.businessType" :goodsList="applymentDetail.goodsList" />
      </template>
    </template>

    <template v-if="applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
      <template
        v-if="
          applymentDetail.applymentStatus != 'DRAFT' &&
          applymentDetail.applymentStatus != 'INQUIRING' &&
          applymentDetail.applymentStatus != 'QUOTING' &&
          applymentDetail.applymentStatus != 'QUOTATION_AUDITING' &&
          applymentDetail.applymentStatus != 'QUOTATION_AUDIT_FAIL'
        "
      >
        <!-- Quotation定制化服务-报价(列表) -->
        <quotation-list :quotationList="applymentDetail.quotationList" />
      </template>
    </template>
  </div>
</template>

<script>
import Package from "@/components/ServiceGather/Package";
import DiyPackage from "@/components/ServiceGather/DiyPackage";
import QuotationList from "@/components/ServiceGather/QuotationList";
import { mapState } from "vuex";
export default {
  components: {
    Package,
    DiyPackage,
    QuotationList,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
